import Vue from "vue";
import VueRouter from "vue-router";
import Store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/",
    component: () =>
      import(/* webpackChunkName: "baseLayout" */ "@/layouts/BaseLayout.vue"),
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: "/",
        // redirect: "/postulacion"
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/HomeView.vue"),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/finalizada",
        name: "formularioTerminado",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/FormularioTerminadoView.vue"
          ),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/postulacion",
        name: "formulario",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/FormularioView.vue"),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/resultados",
        // redirect: "/",
        name: "resultado",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/ResultadoView.vue"),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/postulaciones/inscripcion/manual",
        name: "manual",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/FormularioView.vue"),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/postulaciones/formulario",
        name: "manual",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/FormularioDirectoView.vue"
          ),
        meta: {
          requiresAuth: false
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
